import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import { PAinfoCollapsible } from "./../PAconnectors";

import {
  PAgkRefundPeriods,
  PAgkRefundOption,
  SelectSquare,
  PAgkRefundLine,
  CssTableFlag,
  CssTableCountry
} from "../ffr/PAgkRefund";

import merge from "deepmerge";
import PAwebhooks from "./../PAwebhooks";






export function PAgcGKassets({data}) {


  const handleAddPlatformFromPrices = (
    platformId,
    read = data.keyData.platforms,
    action = "add"
  ) => {
    read.forEach((onePlatform, index) => {
      if (action === "add" && onePlatform["id"] === platformId) {
        handlePlatform(index, "added", "invert");
      }
      if (action === "isadded" && onePlatform.id === platformId) {
        return onePlatform.added ? true : false;
      }
    });
  };

  const handlePlatform = (index, what, value = "invert") => {
    let platf = [...data.keyData.platforms]; // make a separate copy of the array
    let onePlatform = platf[index];
    onePlatform[what] = value === "invert" ? !onePlatform[what] : value;
    if (!onePlatform["added"]) {
      onePlatform["uploaded"] = false;
      onePlatform["enabled"] = false;
    }
    // this.updateStatus(true, platf);
  };





  return (
    <FormGroup border="lg">
    <div className="xsui-form-group--indentation-lg xsui-form-group--primary">
      <div className="xsui-form-group__label">
        Asset delivery
      </div>
      <div className="xsui-form-group__entry">
        <RadioGroup
          name="radio"
          direction="row"
          input={{
            value: data.keyData
              .delivery.value,
            // onChange: e => this.setState({
            //   ...this.state,
            //   delivery: {
            //     value: e.target.value
            //   }
            // })
            // onChange: e =>
            //   this.handleDeliveryType(
            //     e.target.value
            //   )
            }
          }
          options={[
            {
              radioValue: "xsolla",
              label: "Xsolla delivery",
              tooltip:
                "Use Xsolla's server to manage keys and distributives"
            },
            {
              radioValue: "self",
              label: "Custom delivery",
              tooltip:
                "Use your own server that receives webhooks to manage keys and distributives"
            }
          ]}
        />
      </div>
    </div>



    {/* SELF */}
    {data.keyData.delivery.value ===
      "self" && (
      <FormGroup indentation="lg">
        {/* <div className="xsui-form-group--indentation-lg">
                <Notification status="info">
                  Note: you will need to enable
                  and test webhooks to start
                  selling.
                  <br />
                  <b>
                    <a href="#">
                      Webhooks Documentation
                    </a>
                  </b>
                </Notification>
              </div> */}

        <div className="xsui-form-group--indentation-lg">
          <PAwebhooks
            handleWebhooks={this.handleWebhooks.bind(
              this
            )}
          />
        </div>
      </FormGroup>
    )}
  </FormGroup>


  )
}


